import { render, staticRenderFns } from "./FormStatisticsGroup.vue?vue&type=template&id=221e2a83&"
import script from "./FormStatisticsGroup.vue?vue&type=script&lang=js&"
export * from "./FormStatisticsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports